module.exports = __webpack_public_path__ + "04_glasses_blue.ec05284d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/04_glasses_blue.png
// module id = DrBf
// module chunks = 0